// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn___t8GZ","is-primary":"Button_is-primary__Z7vVN","is-secondary":"Button_is-secondary__GSqWQ","is-back":"Button_is-back__eMg7f"};